import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Message from 'components/Message';
import { TooltipContent, TooltipToggle } from 'components/Tooltip';
import { ICONS } from 'constants/icons';
import { schedulePropTypes } from 'constants/propTypes';

import messages from './ScheduleDetailV2.messages';
import StatsCard, { statsCardElement as element } from './StatsCard';

const EMPTY_CLASSPASS_TOTAL = 0;
const MAX_BOOKINGS_TOOLTIP_NAME_PREFIX = 'booking-overview-max-bookings';

const ClassPassBookingsCard = ({ schedule }) => {
  const { scheduleId, smartspotEnabled, spots } = schedule;
  const { classpassBooked = EMPTY_CLASSPASS_TOTAL, classpassTotal = EMPTY_CLASSPASS_TOTAL } = spots || {};
  const tooltipName = `${MAX_BOOKINGS_TOOLTIP_NAME_PREFIX}-${scheduleId}`;
  const maxBookingsTooltipMessage = smartspotEnabled
    ? messages.maxBookingsTooltipSmartspot
    : messages.maxBookingsTooltipStandard;
  const hasMaxBookings = classpassTotal !== EMPTY_CLASSPASS_TOTAL;

  const value = smartspotEnabled ? (
    <span>{classpassBooked}</span>
  ) : (
    <Message
      message={messages.classPassBookingsFraction}
      values={{
        muted: text => <span className={element('value-muted')}>{text}</span>,
        span: text => <span>{text}</span>,
        x: classpassBooked,
        y: classpassTotal,
      }}
    />
  );

  const footer = (
    <div className={element('footer-meta')}>
      {hasMaxBookings ? (
        <Message message={messages.maxBookings} values={{ count: classpassTotal }} />
      ) : (
        <Message message={messages.maxBookingsUnavailable} />
      )}
      <TooltipToggle name={tooltipName}>
        <Isvg className={element('tooltip-icon')} src={ICONS.infoGrey} />
      </TooltipToggle>
      <TooltipContent className={element('tooltip-content')} hoverable name={tooltipName} place="top">
        <Message message={maxBookingsTooltipMessage} />
      </TooltipContent>
    </div>
  );

  return (
    <StatsCard
      dataCypress="booking-overview-classpass-card"
      footer={footer}
      label={<Message message={messages.classPassBookingsLabel} />}
      value={value}
    />
  );
};

ClassPassBookingsCard.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes).isRequired,
};

export default ClassPassBookingsCard;
